<template>
	<div class="businessAdd">
		<div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中"    element-loading-spinner="el-icon-loading"    element-loading-background="rgba(255, 255, 255, 0.8)">
			<div>         <el-link type="primary" @click="back"> << 返回用户列表</el-link></div>
      <div class="pageTitle">
        <span  v-if="selectType==1">{{name}}</span>
        <span v-if="selectType==2">{{companyName}}</span>
      </div>
      <!-- 第一块 -->
			<div class="panelBlock">
				<div class="panelTitle">基本信息</div>
				<div class="panelContent">
          <div class="oneLine">
            <div class="oneItem">
              <div class="label"> 注册类型：</div>
              <div class="rightInput">
                <span v-if="selectType==1">个人</span>
                <span v-if="selectType==2">公司</span>
              </div>
            </div>
            <div class="oneItem" v-if="selectType==2">
              <div class="label"> 公司地址：</div>
              <div class="rightInput">
                <span>{{infoObj.company_province}}</span>
                <span>{{infoObj.company_city}}</span>
                <span>{{infoObj.company_district}}</span>
                <span>{{infoObj.user_address}}</span>
              </div>
            </div>
          </div>
          <div class="oneLine">
            <div class="oneItem">
              <div class="label"> 注册/登录手机号：</div>
              <div class="rightInput bold">
                <span>{{phone}}</span>
              </div>
            </div>
            <div class="oneItem">
              <div class="label"> 用户状态：</div>
              <div class="rightInput bold">
                {{ userState[user_state] }}
              </div>
              <el-button plain type="primary" class="clickBtn" @click="toEdit" size="mini" v-show="function_otherUserControl">去审核</el-button>
            </div>
          </div>
          <div class="oneLine">
            <div class="oneItem">
              <div class="label"> 注册时间：</div>
              <div class="rightInput ">
                {{user_register_time}}
              </div>
            </div>
            <div class="oneItem">
              <div class="label"> 身份标签：</div>
              <div class="rightInput"  >
                <span v-if="type==1">供应商</span>
                <span v-if="type==2">销售商</span>
              </div>
            </div>
          </div>
          <div class="oneLine">
            <div class="oneItem">
              <div class="label">联系人姓名：</div>
              <div class="rightInput">
                {{contactName}}
              </div>
            </div>
            <div class="oneItem">
              <div class="label">联系人手机：</div>
              <div class="rightInput">
                {{contactPhone}}
              </div>
              <el-button plain type="primary" class="clickBtn"  @click="toEdit"  size="mini" v-show="function_addAndEditUser">去修改</el-button>
            </div>

          </div>
          <div class="oneLine">
            <div class="oneItem long">
              <div class="label">品牌：</div>
              <div class="rightInput">
                <span v-if="brandArr.length==0">暂无</span>
                <el-tag type="danger" effect="plain"  size="mini" v-for="(list,index) in brandArr" style="margin: 5px;">{{list}}</el-tag>
                <!-- <span v-for="(list,index) in brandArr" style="margin-right: 15px;">{{list}}</span> -->

              </div>
              <el-button plain type="primary"   @click="toEdit"  size="mini" v-show="function_addAndEditUser">去添加</el-button>
            </div>

          </div>
				</div>
			</div>
      <!-- 第2块 -->
      <div class="panelBlock">
      	<div class="panelTitle">商品信息</div>
      	<div class="panelContent">
          <div class="oneLine">
            <div class="oneItem">
              <div class="label">商品总款数：</div>
              <div class="rightInput">
                {{goodsDetailObj.itemSum |turn0}}款
                <el-link type="primary" @click="toGoodsList">查看商品列表详情>></el-link>
              </div>
            </div>
            <div class="oneItem">
              <el-button type="primary"  size="mini" @click="toAddGoodsPage" v-show="function_otherUserControl">添加商品</el-button>
              <el-button type="primary"  size="mini" @click="openAddGoods" v-show="function_otherUserControl">批量添加商品</el-button>
              <downloadbtn :name="userName" :isHideName="true" :id="keyUserId"></downloadbtn>
            </div>
          </div>
          <div class="oneLine">
            <div class="oneItem">
              <div class="label">在售款数：</div>
              <div class="rightInput">
                {{goodsDetailObj.itemOn |turn0}}款
              </div>
            </div>
          </div>
          <div class="oneLine">
            <div class="oneItem">
              <div class="label">下架款数：</div>
              <div class="rightInput">
                {{goodsDetailObj.itemOff |turn0}}款
              </div>
            </div>
          </div>
          <div class="oneLine">
            <div class="oneItem">
              <div class="label">当前可售总库存数量：</div>
              <div class="rightInput">
                {{goodsDetailObj.sumSku |turn0}}件
                <el-link type="primary" @click="toStockList">查看商品库存列表>></el-link>
              </div>
            </div>
          </div>
          <div class="oneLine">

          </div>
      	</div>
      </div>
      <!-- 第2块 -->
      <div class="panelBlock">
      	<div class="panelTitle">订单信息</div>
      	<div class="panelContent">
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">当前被锁仓处于锁仓商品数量：</div>
              <div class="rightInput">
                {{orderDetailObj.nowLockNumBySup.sumReserveQuantity|turn0}}件
              </div>
            </div>
            <div class="oneItem">
              <span class="des">说明：未进行同意或者拒绝操作和未失效的锁仓数量</span>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">当前发起锁处于锁仓状商品数量：</div>
              <div class="rightInput">
                {{orderDetailObj.nowLockNumByDe.sumReserveQuantity|turn0}}件
              </div>
            </div>
            <div class="oneItem">
              <span class="des">说明：未进行同意或者拒绝操作和未失效的锁仓数量</span>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计被锁仓订单数：</div>
              <div class="rightInput">
                {{orderDetailObj.allLockNumBySup.totalOrderCount|turn0}}笔
              </div>
            </div>
            <div class="oneItem">
              <span class="des">说明：历史所有被锁仓订单笔数</span>
            </div>

          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计被锁仓商品数：</div>
              <div class="rightInput">
               {{orderDetailObj.allLockNumBySup.sumReserveQuantity|turn0}}件
              </div>
            </div>
            <div class="oneItem">
              <span class="des">说明：历史所有被锁仓商品件数</span>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计发起锁仓订单数：</div>
              <div class="rightInput">
                {{orderDetailObj.allLockNumByDe.totalOrderCount|turn0}}笔
              </div>
            </div>
            <div class="oneItem">
              <span class="des">说明：历史所有当前用户使用销售商发起的锁仓笔数</span>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计发起锁仓商品数：</div>
              <div class="rightInput">
                {{orderDetailObj.allLockNumByDe.sumReserveQuantity|turn0}}件
              </div>
            </div>
            <div class="oneItem">
              <span class="des">说明：历史所有当前用户使用销售商发起的商品件数</span>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计被下单订单数：</div>
              <div class="rightInput">
                {{orderDetailObj.orderPurchaseInfoBySup.totalOrderCount|turn0}}笔
              </div>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计被下单商品数：</div>
              <div class="rightInput">
                {{orderDetailObj.orderPurchaseInfoBySup.sumOrdePurchaseQuantity|turn0}}件
              </div>
            </div>

          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计发起下单订单数：</div>
              <div class="rightInput">
                {{orderDetailObj.orderPurchaseInfoByDe.totalOrderCount|turn0}}笔
              </div>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计发起下单商品数：</div>
              <div class="rightInput">
                {{orderDetailObj.orderPurchaseInfoByDe.sumOrdePurchaseQuantity|turn0}}件
              </div>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计作为销售商身份清算订单数：</div>
              <div class="rightInput">
                {{orderDetailObj.lqInfoByDe.totalOrderCount|turn0}}笔
              </div>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计作为销售商身份清算商品数：</div>
              <div class="rightInput">
                {{orderDetailObj.lqInfoByDe.sumOrdePurchaseQuantity|turn0}}件
              </div>
            </div>
            <div class="oneItem">
              <el-link type="primary" @click="toPageOrder_lock">查看锁仓订单列表详情>> </el-link>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计作为供应商身份清算订单数：</div>
              <div class="rightInput">
                {{orderDetailObj.lqInfoBySup.totalOrderCount |turn0}}笔
              </div>
            </div>
            <div class="oneItem">
              <el-link type="primary" @click="toPageOrder_take">查看下单订单列表详情>> </el-link>
            </div>
          </div>
          <div class="oneLine">
            <!-- 1个  item -->
            <div class="oneItem">
              <div class="label">累计作为供应商身份清算商品数：</div>
              <div class="rightInput">
                {{orderDetailObj.lqInfoBySup.sumOrdePurchaseQuantity|turn0}}件
              </div>
            </div>
            <div class="oneItem">
              <el-link type="primary" @click="toPageOrder_clear">查看清算订单列表详情>> </el-link>
            </div>
          </div>
      	</div>
      </div>

		</div>
    <uploadgroup v-show="isShowUploadGroupModal" :info="currentUploadModal" @close="closeUploadModal" @success="closeUploadModalAndSucess"></uploadgroup>
	</div>
</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
  import addbrand from '@/components/addBrand.vue'
  import downloadbtn from '@/components/downloadGoodsBtn.vue'
  import uploadgroup from '@/components/uploadgroup.vue'
	export default {
		name: 'adminIndex',
		data() {
			return {
        selectType:'',
				isLoading:false,
        isShowModal:false,
        name:'',
        phone:'',
        type:'',
        contactName:'',
        userName:'',
        user_state:'',
        contactPhone:'',
        companyName:'',
        brandArr:[],
        keyUserId:'',
        user_register_time:'',
        orderDetailObj:{
          allLockNumByDe: {totalOrderCount: "0",sumReserveQuantity:0},
          allLockNumBySup: {totalOrderCount: "0",sumReserveQuantity:0},
          lqInfoByDe: {sumOrdePurchaseQuantity: 0, totalOrderCount: "0"},
          lqInfoBySup: {sumOrdePurchaseQuantity: 0, totalOrderCount: "0"},
          nowLockNumByDe: {totalOrderCount: "0",sumReserveQuantity:0},
          nowLockNumBySup: {totalOrderCount: "0",sumReserveQuantity:0},
          orderPurchaseInfoByDe: {sumOrdePurchaseQuantity: 0, totalOrderCount: "0"},
          orderPurchaseInfoBySup:{sumOrdePurchaseQuantity: 0, totalOrderCount: "0"}
        },
        goodsDetailObj:{},

        isShowAddBrandModal:false,
        currentAddModalObj:{},
        tagWord: {
          y:'green',
          n:'grey',
          p:'red',
        },
        userState:{
          y:'通过',
          n:'被拒绝',
          p:'待审核',
        },
        isShowUploadGroupModal:false,
        currentUploadModal:{},
        infoObj:{},


			}
		},
    filters:{
      turn0:function(val){
        if(!val){
          return 0
        }else{
          return val
        }
      }
    },
		computed: {
			IMG_PREV(){
				return api.imgPrev
			},
      function_viewUserDetail() {
        return utils.getCurrentFunction().indexOf("viewUserDetail")>-1
      },
      function_addAndEditUser() {
        return utils.getCurrentFunction().indexOf("addAndEditUser")>-1
      },
      function_otherUserControl() {
        return utils.getCurrentFunction().indexOf("otherUserControl")>-1
      },
		},
		components: {
		  addbrand,downloadbtn,uploadgroup
		},
		methods: {
      // 跳转“添加商品”页面
      toAddGoodsPage () {
        this.$router.push('/goods/add?userId=' + this.$route.query.userId)
      },
      openAddGoods() {
        this.isShowUploadGroupModal=true
        this.currentUploadModal={
          user_organization_name:this.userName,
          user_id:this.keyUserId
        }
      },
      closeUploadModal(){
        console.log("批量上传关闭方法被触发")
        this.isShowUploadGroupModal = false
      },
      closeUploadModalAndSucess(){
        console.log("批量上传关闭并且成功方法被触发")
        this.isShowUploadGroupModal = false
        this.currentUploadModal = {}
        this.initPage();
      },
      toPageOrder_lock(){
        this.$router.push("/order/lockList?" +"&searchUser=" +this.$route.query.userId+"&searchUserName="+this.userName)
      },
      toPageOrder_take(){
        this.$router.push("/order/orderList?" +"&searchUser=" +this.$route.query.userId+"&searchUserName="+this.userName)
      },
      toPageOrder_clear(){
        this.$router.push("/order/clearList?" +"&searchUser=" +this.$route.query.userId+"&searchUserName="+this.userName)
      },
      toGoodsList(){
        this.$router.push("/goods/list?" +"&searchUser=" + this.$route.query.userId+"&searchUserName="+this.userName)
      },
      toStockList() {
        this.$router.push('/stock/list?userId=' + this.$route.query.userId)
      },
      back(){
      	this.$router.back()
      },
      toEdit(){
        let _this=this
        this.$router.push('/user/edit?userId=' +_this.$route.query.userId);
      },
      closeAddModal(){
        console.log("关闭方法被触发")
        this.isShowAddBrandModal=false
      },
      closeAddModalAndSucess(){
        console.log("关闭并且成功方法被触发")
        this.isShowAddBrandModal=false
        this.currentAddModalObj={}
        this.getDetail()
      },
      toEditBrand(){
          let _this=this
          this.isShowAddBrandModal=true
          let arg={
            userId: _this.$route.query.userId
          }
          let brandArr=[]
          ajaxPost('/commodity/brandListByUser', arg).then(function(res){
            console.log(res)
            if(res.errorCode==200){
              res.data.map(function(item,index){
                brandArr.push(item.item_display_name)
              })

            }else{
              brandArr=[]
            }
            _this.currentAddModalObj={
              userId: _this.$route.query.userId,
              name:_this.companyName||_this.name,
              brandArr:brandArr
            }
          })


      },
      getGoodsDetail(){

        let _this=this
        let userId=this.$route.query.userId
        let arg={
          userId:userId
        }
        ajaxPost('/commodity/getItemInfo', arg).then(function(res) {
          if(res.errorCode==200){
            _this.goodsDetailObj=res.data
          }else{
          }
        }, function(res) {})
      },
      getOrderDetail(){
        let _this=this
        let userId=this.$route.query.userId
        let arg={
          userId:userId
        }
        ajaxPost('/dwOrder/getDwOrderInfo', arg).then(function(res) {
          if(res.errorCode==200){
            _this.orderDetailObj=res.data

          }else{
          }
        }, function(res) {})
      },
      getDetail(){
        let _this=this
        let userId=this.$route.query.userId
        let arg={
          userId:this.$route.query.userId
        }
        // 查询基本信息
        ajaxPost('/admin/getDwUserInfo', arg).then(function(res) {
          if(res.errorCode==200){

            // user_contact_cellphone: "13023621792"
            // user_id: "543"
            // user_individual_name: "5433姓名222"
            // user_last_type: ""
            // user_organization_name: "543司名"
            // user_register_time: "2020-07-13 17:27:13"
            // user_state: "y"

            let resObj=res.data[0]||{}
            _this.infoObj=resObj
            _this.name=resObj.user_individual_name
            _this.phone=resObj.phone
            _this.keyUserId=resObj.user_id
            _this.type=resObj.user_initial_type
            _this.contactName=resObj.user_contact_person
            _this.contactPhone=resObj.user_contact_cellphone
            _this.companyName=resObj.user_organization_name
            _this.user_state=resObj.user_state
            _this.user_register_time=resObj.user_register_time
            _this.userName=_this.companyName||_this.name
            if(_this.companyName){
              _this.selectType=2
            }else{
              _this.selectType=1
            }

          }else{
          }
        }, function(res) {})
        // 查询品牌
        let brandArr=[]
        ajaxPost('/commodity/brandListByUser', arg).then(function(res){
          console.log(res)
          if(res.errorCode==200){
            res.data.map(function(item,index){
              brandArr.push(item.item_display_name)
            })

          }else{
            brandArr=[]
          }
          _this.brandArr=brandArr
        })
      },
      submitClick(){
        let _this=this
        let arg={
          // phone:_this.phone,
          userId:_this.keyUserId,
          // userIndividualName:_this.name,
          // userOrganizationName:_this.companyName,
          // userInitialType:_this.type,
          companyKeyPerson:_this.contactName,
          companyKeyPersonPhone:_this.contactPhone,
          userDeviceInfo:navigator.userAgent,
        }
        if(this.selectType==1){//个人，公司为空
          arg.userIndividualName=this.name
          arg.userOrganizationName=""
        }else if(this.selectType==2){//公司,个人为空
          arg.userOrganizationName=this.companyName
          arg.userIndividualName=""
        }
        console.log(arg)
        ajaxPost('/admin/updateUserInfoByUid', arg).then(function(res) {
          if(res.errorCode==200){
            _this.$message({
               message: "编辑成功",
               type: 'success',
            });
            _this.$router.back()
          }else{
            // _this.$message({
            //    message: res.errorMsg,
            //    type: 'error',
            // });
          }
        }, function(res) {})

      },
      openModal(){
        let _this=this
        if(!this.selectType||!this.phone||!this.type){
          _this.$message({
             message:"带*号的为必填项",
             type: 'error',
          });
        }else if(!json.phoneReg.test(this.phone)){
          _this.$message({
             message:"登录用手机号格式不正确",
             type: 'error',
          });
        }else if(this.contactPhone&&(!json.phoneReg.test(this.contactPhone))){
          _this.$message({
             message:"联系人手机号格式不正确",
             type: 'error',
          });
        }else if(this.selectType==1){
          if(!this.name){
            _this.$message({
               message:"用户姓名为必填项",
               type: 'error',
            });
          }else{
            _this.isShowModal=true
          }

        }else if(this.selectType==2){
          if(!this.companyName){
            _this.$message({
               message:"公司名称为必填项",
               type: 'error',
            });
          }else{
            _this.isShowModal=true
          }
        }

      },
			closeModal(){
				this.isShowModal=false
			},
      initPage(){
        this.getDetail()
        this.getGoodsDetail()
        this.getOrderDetail()
      }
		},
		mounted() {
			let _this = this
      this.initPage()
		},
	}
</script>

<style scoped lang="scss">
  // .el-button--mini{padding:4px}
	* {
		// outline: 1px solid blue;
	}
  .pageTitle{font-weight: bold;text-align: center;font-size: 24px;margin-bottom: 10px;;}
  .businessAdd{
    background: #fff;; padding-bottom:100px;padding: 10px;;
    .panelBlock{
      vertical-align: top;margin-bottom: 10px;
      border:0.5px solid #a5c6f8;
      .panelTitle{font-weight: bold;padding:10px;background: #a5c6f8;color:#333;}
      .panelContent{
        padding:10px 10px; padding-bottom: 20px;
      }
    }
    .btnBox{
      // text-align: center;
      padding:20px;
    }
  }
  .oneLine{
    padding:5px;
    .oneItem{display: inline-block; width:350px; margin-right: 20px;
      .label{display: inline-block;color:#666;}
      .rightInput{display: inline-block;}
      position: relative;

      .clickBtn{position: absolute;right:50px;}
    }
    .oneItem.long{width: 80%;}
    .des{color:#999;font-size: 12px;}

  }
  .bottomBtnLine{padding-left:30px;}

</style>



// WEBPACK FOOTER //
// src/pages/user/detail.vue